import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NoData } from '../components/common/NoData';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { updateTotalPrice, getQuote, getRop } from '../features/product';
import { Loader } from '../components/common/loader';
import { DynamicFormModal } from '../components/common/dynamic-form-modal';
import { createFormData } from '../utils/commonHelper';
import { useAuth } from '../auth/AuthProvider';

const CompanyList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { ropRequestData } = location.state || {};
    const token = localStorage.getItem('token') ? localStorage.getItem('token') : null;
    const [inputFormShow, setInputFormShow] = useState(false);
    const [inputParameters, setInputParameters] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState({});
    const { companyList, companyLoader, status } = useSelector((state) => state.product);
    const { setModalIsOpen } = useAuth();

    const handleCoverSelection = (e, companyId) => {
        if (e.target.checked) {
            dispatch(updateTotalPrice({ value: e.target.value, customAction: 'increment', id: companyId }))
        } else {
            dispatch(updateTotalPrice({ value: e.target.value, customAction: 'decrement', id: companyId }))
        }
    }

    const buyNowHandler = (item) => {
        localStorage.setItem('product_detail', JSON.stringify({ productName: item?.sub_product_name, companyName: item?.insurance_company_name, price: item?.fixed_rate_value }));

        if (token) {
            if (item && item?.api_input_parameters && item?.api_input_parameters?.length) {
                setInputFormShow(true);
                setSelectedCompany(item);
                setInputParameters(item?.api_input_parameters);
            } else {
                dispatch(getQuote({ ...item?.extracted_data, insurance_company_product_mapping_id: item?.id }));
                navigate('/checkout');

            }
        } else {
            // navigate('/signin', { state: { fromCheckout: true } });
            setInputFormShow(false)

            setModalIsOpen(true)
        }
    }

    const handleSubmit = (event, data) => {
        event.preventDefault();
        const convertedFormData = createFormData(data);
        convertedFormData.append('insurance_company_product_mapping_id', selectedCompany?.id);
        const convertedExtractedData = createFormData(selectedCompany?.extracted_data);
        for (const [key, value] of convertedExtractedData.entries()) {
            convertedFormData.append(key, value);
        }
        dispatch(getQuote(convertedFormData));
        navigate('/checkout');
    }

    useEffect(() => {

        if (ropRequestData) {
            dispatch(getRop(ropRequestData));
            
        }
    }, [dispatch, status, ropRequestData]);

    if (companyLoader) {
        return <Loader type="logo-gif" />
    }

    return (
        <section className="list-page">
            <div className='container'>
                <div className="row">
                    {/* <ul className="list-boxs"> */}
                    {companyList && companyList.length ?
                        companyList.map((item, index) =>
                            <div className="col" key={"company-cards-" + index}>
                                <div className='card'>
                                    <div className="card-header">
                                        <div className="logo-header">
                                            <span><b>Company Name:</b> {item?.insurance_company_name}</span>
                                        </div>
                                        <div className="idv-price">
                                            <ul>
                                                <li><h4>IDV Cover</h4><p>3,26,400</p></li>
                                                <li><h4>Claims</h4><p>98%</p></li>
                                            </ul>
                                        </div>
                                        <div className="price-btn">
                                            <h5>Base Price <div>{item?.fixed_rate_value}</div></h5>
                                        </div>
                                    </div>
                                    <div className='card-info'>
                                        <>
                                            <h3>Included Covers</h3>
                                            <div className='include-list'>
                                                {
                                                    item?.cover_mapping && item?.cover_mapping.length ?
                                                        <ul>
                                                            {item?.cover_mapping.map((cover_item, index) =>
                                                                <li key={"cover_master_" + index}>{cover_item?.cover_name}</li>
                                                            )}
                                                        </ul>
                                                        : <NoData msg="No covers available!!" />
                                                }
                                            </div>
                                            <div className='include-list-optional'>
                                                <h3>Optional Covers</h3>
                                                {
                                                    item?.standard_cover_mapping && item?.standard_cover_mapping.length ?
                                                        <ul>
                                                            {item?.standard_cover_mapping.map((cover_item, index) =>
                                                                <li key={"standard_cover_" + index}>
                                                                    <input
                                                                        type='checkbox'
                                                                        name={"cover-name" + cover_item?.cover_master_id}
                                                                        value={cover_item?.rate || 0}
                                                                        onChange={(e) => handleCoverSelection(e, item?.id)} />
                                                                    {cover_item?.cover_name}
                                                                </li>
                                                            )}
                                                        </ul>
                                                        : <NoData msg="No optional covers available!!" />
                                                }
                                            </div>
                                        </>
                                    </div>
                                    <div className='card-footer'>
                                        <div className="total-value">
                                            <h5>Total Payment :{item?.fixed_rate_value}</h5>
                                        </div>
                                        <div className="details">
                                            <ul>
                                                <li><Link to="#">17 Branches</Link></li>
                                                <li><Link to="#">Details</Link></li>
                                            </ul>
                                        </div>
                                        <div className="booknow-btn">
                                            <button type="button" className="btn booknow-btn"
                                                onClick={() => buyNowHandler(item)} >Buy Now</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                        : ""}
                    {/* </ul> */}
                </div>
            </div>

            <DynamicFormModal
                show={inputFormShow}
                handleClose={() => setInputFormShow(false)}
                inputParameters={inputParameters}
                handleSubmit={handleSubmit}
            />
        </section>
    )
}

export default CompanyList;